export default "__VITE_ASSET__Cu$VgaLl__"